// private functions

import Logger from 'src/initializers/Logger'

const Classes = 'Boolean Number String Function Array Date RegExp Object Error Symbol'.split(' ')
const class2type = {}
Classes.forEach(klass => {
  class2type[ '[object ' + klass + ']' ] = klass.toLowerCase()
})

function twoDigitInteger (int) {
  return (int < 10 ? '0' + int : int)
}
function randDigitNumbers (length) {
  let rand = ''
  while (rand.length < length) {
    rand = rand + Math.floor(Math.random() * 10)
  }
  return rand
}

// exported functions

export function getType (obj) {
  if (obj === null) {
    return obj + ''
  }
  // Support: Android <= 2.3 only (functionish RegExp)
  return typeof obj === 'object' || typeof obj === 'function'
    ? class2type[ ({}).toString.call(obj) ] || 'object'
    : typeof obj
}

// http://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
export function generateUUID () {
  let d = new Date().getTime()
  if (window.performance && typeof window.performance.now === 'function') {
    d = d + window.performance.now() // use high-precision timer if available
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
  })
}

export function extractParamsFromArguments (args, keys) {
  if (args.length === 0) { return {} }
  const res = {}
  if (getType(args[0]) === 'object') {
    keys.forEach(key => { res[key] = args[0][key] })
  } else {
    Logger.warn('(DeprecationWarning) using array of arguments is deprecated - use object instead')
    keys.forEach((key, idx) => { res[key] = args[idx] })
  }
  return res
}

export function getUuid ({ capturedAt = new Date(), userId = randDigitNumbers(10) } = {}) {
  const month = capturedAt.getMonth() + 1
  const day = capturedAt.getDate()
  const hours = capturedAt.getHours()
  const minutes = capturedAt.getMinutes()

  const date = '' + capturedAt.getFullYear() + twoDigitInteger(month) + twoDigitInteger(day)
  const time = '' + twoDigitInteger(hours) + twoDigitInteger(minutes)

  const rand = randDigitNumbers(4)

  return date + '-' + time + '-' + rand + '-' + userId
}

export function isURLencodable (data, arrayEncountered = false) {
  switch (getType(data)) {
    case 'array':
      if (arrayEncountered) { return false }
      return data.map(x => isURLencodable(x, true)).indexOf(false) === -1
    case 'object':
      if (arrayEncountered) { return false }
      return Object.entries(data).map(([key, value]) => isURLencodable(value, arrayEncountered)).indexOf(false) === -1
    case 'string':
    case 'boolean':
    case 'number':
    case 'date':
      return true
    default:
      return false // unsafe type, everything is converted to a string, ...
  }
}

// https://github.com/visionmedia/superagent/blob/bf1a87ab7556c6a5c22e2bd9ce27f9871cae5e59/lib/client.js#L85
/* eslint-disable */

export function serialize(obj) {
  if (!isObject(obj)) return obj;
  var pairs = [];
  for (var key in obj) {
    pushEncodedKeyValuePair(pairs, key, obj[key]);
  }
  return pairs.join('&');
}

function isObject(obj) {
  return null !== obj && 'object' === typeof obj;
}

function pushEncodedKeyValuePair(pairs, key, val) {
  if (val != null) {
    if (Array.isArray(val)) {
      val.forEach(function(v) {
        pushEncodedKeyValuePair(pairs, key + '[]', v); // the only change: " + '[]' "
      });
    } else if (isObject(val)) {
      for(var subkey in val) {
        pushEncodedKeyValuePair(pairs, key + '[' + subkey + ']', val[subkey]);
      }
    } else {
      pairs.push(encodeURIComponent(key)
        + '=' + encodeURIComponent(val));
    }
  } else if (val === null) {
    pairs.push(encodeURIComponent(key));
  }
}

/* eslint-enable */



// WEBPACK FOOTER //
// ./src/initializers/Utils.js